import {propEq, find, curry} from 'ramda'

/**
 * 
 * @param {Array} variants - array of variants
 * @returns {Object} - variant object
 */
const getVariantFromVariantsAndOptions = curry((x, y, a, b) => x(y(b))(a))(find, propEq('options'))

export default getVariantFromVariantsAndOptions;